import React, { Component } from 'react'

import { faCircle } from '@fortawesome/free-solid-svg-icons'
import {
	faWifi,
	faSnowflakes,
	faBolt,
	faMicrochip,
	faMouseField,
	faPersonWalking,
	faTemperatureThreeQuarters,
	faMeterBolt,
	faPlugCircleBolt,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { TEMPERATURE_SENSOR_TYPES } from '#helper/deviceTypes'

// DOKU:

export default class IconsDeviceType extends Component {
	icon = (devicetype) => {
		// Temperature sensors (shared with alarmLogic for alarmTemperatureDeactivated icon)
		if (TEMPERATURE_SENSOR_TYPES.includes(devicetype)) {
			return { icon: faTemperatureThreeQuarters }
		}

		switch (devicetype) {
			// Gateway
			case 'gateway':
			case 'Gateway':
				return { icon: faWifi }

			// Mouse Trap
			case 'Xignal Rattrap':
				return { icon: faMouseField }

			// Rat Trap
			case 'Xignal Mousetrap':
				return { custom: 'fa-mouse-front' }

			// Mouse Trap Dual
			case 'Traplinked JERRY3 Mouse':
				return { custom: 'fa-mouse-dual' }

			// Rat Trap
			case 'Traplinked JERRY3 Rat':
				return { icon: faMouseField }

			// Snow
			case 'Milesight UC501 Snow':
				return { icon: faSnowflakes }

			// Elec. Meter
			case 'Adeunis Pulse V4 - Electricity':
				return { icon: faMeterBolt }

			// Elec. Meter
			case 'Milesight WS523':
				return { icon: faPlugCircleBolt }

			// Electricity Meter
			case 'HarvyLR-36':
			case 'MCF LW12PLG':
				return { icon: faBolt }

			// Motion
			case 'Xignal Motion Sensor':
				return { icon: faPersonWalking }

			// IO-Boxes
			case 'MCF LW13IO':
			case 'MClimate 16A Dry Switch':
				return { icon: faMicrochip }

			default:
				return { icon: faCircle }
		}
	}

	render() {
		const { type, beat, className, iconOverride } = this.props
		// Custom icon override (e.g. alarm deactivated: fa-kit icon)
		if (iconOverride === 'alarmTemperatureDeactivated') {
			return (
				<i
					className={
						'fa-kit fa-regular-temperature-three-quarters-circle-exclamation ' +
						(beat ? 'fa-beat ' : '') +
						className
					}
				></i>
			)
		}
		if (this.icon(type).custom) {
			return (
				<i
					className={
						'fa-kit ' +
						this.icon(type).custom +
						' ' +
						(beat ? 'fa-beat' : '') +
						' fa-lg ' +
						className
					}
				></i>
			)
		} else {
			return (
				<FontAwesomeIcon
					icon={this.icon(type).icon}
					beat={beat}
					className={className}
				/>
			)
		}
	}
}
